// @flow
export const RESET = "bookingInsurance/RESET"
export const SELECT = "bookingInsurance/SELECT"
export const DESELECT = "bookingInsurance/DESELECT"
export const SUBMIT = "bookingInsurance/SUBMIT"
export const SUBMIT_REQUEST = "bookingInsurance/SUBMIT_REQUEST"
export const SUBMIT_SUCCESS = "bookingInsurance/SUBMIT_SUCCESS"
export const SUBMIT_FAILURE = "bookingInsurance/SUBMIT_FAILURE"
